var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TiktokComp",
    clipPath: "url(#clip0_841_4416)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.1781 5.20083C22.9628 3.81349 22.2931 2.03182 22.2936 0.1875H16.8003V22.2319C16.7579 23.4249 16.2543 24.5548 15.3954 25.3838C14.5366 26.2128 13.3895 26.6762 12.1958 26.6764C9.67139 26.6764 7.57361 24.6142 7.57361 22.0542C7.57361 18.9964 10.5247 16.7031 13.5647 17.6453V12.0275C7.43139 11.2097 2.0625 15.9742 2.0625 22.0542C2.0625 27.9742 6.96917 32.1875 12.1781 32.1875C17.7603 32.1875 22.2936 27.6542 22.2936 22.0542V10.8719C24.5212 12.4717 27.1956 13.33 29.9381 13.3253V7.83194C29.9381 7.83194 26.5958 7.99194 24.1781 5.20083Z",
    fill: "#FFFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_841_4416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.1875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.1d204a2ee16d05e39e4721e15e04696f.svg";
export { ForwardRef as ReactComponent };